import React from "react";

import {Typography} from "@mui/material";
import {typografNode} from "../../utils/typograf";
import {SxProps} from "@mui/material/styles";

type IntroHeaderProps = {
    children: React.ReactNode;
    sx?: SxProps;
};

function IntroHeader({children, sx}: IntroHeaderProps) {
    return (
        <Typography component="h1" variant="h1" sx={{
            fontWeight: '950',
            fontFamily: 'Nexa, Roboto, sans-serif',
            letterSpacing: 0,
            '@media screen and (min-width: 1400px)': {
                fontSize: '48px',
                lineHeight: 1.22,
            },
            '@media screen and (min-width: 1200px) and (max-width: 1399px)': {
                fontSize: '48px',
                lineHeight: 1.22,
            },
            '@media screen and (min-width: 992px) and (max-width: 1199px)': {
                fontSize: '44px',
                lineHeight: 1.22,
            },
            '@media screen and (min-width: 768px) and (max-width: 1199px)': {
                fontSize: '44px',
                lineHeight: 1.22,
            },
            '@media screen and (max-width: 767px)': {
                fontSize: '40px',
                lineHeight: 1.22,
            },
            '@media screen and (max-width: 575px)': {
                overflowWrap: 'normal',
                lineHeight: 1.22,
            },
            ...sx
        }}>
            {typografNode(children)}
        </Typography>
    );
}

export default IntroHeader
